import React, { FC, useState } from 'react';
import { IoEyeOffOutline, IoEyeOutline } from 'react-icons/io5';

import {
  InputShell,
  Label,
  PasswordFieldInput,
  PasswordFieldWrapper,
  ToggleButton,
} from './styled';

export interface PasswordInputProps {
  label?: string;
  placeholder?: string;
  value: string;
  disabled?: boolean;
  // eslint-disable-next-line no-unused-vars
  onChange: (value: string) => void;
}

export const PasswordInput: FC<PasswordInputProps> = ({
  label,
  placeholder,
  value,
  disabled,
  onChange,
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <PasswordFieldWrapper>
      {label && <Label>{label}</Label>}
      <InputShell $disabled={disabled}>
        <PasswordFieldInput
          type={visible ? 'text' : 'password'}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          autoComplete="new-password"
          onChange={(e) => onChange(e.currentTarget.value)}
        />
        <ToggleButton
          type="button"
          aria-label={visible ? 'Hide password' : 'Show password'}
          disabled={disabled}
          onClick={() => setVisible((prev) => !prev)}
        >
          {visible ? <IoEyeOffOutline size={20} /> : <IoEyeOutline size={20} />}
        </ToggleButton>
      </InputShell>
    </PasswordFieldWrapper>
  );
};
